import React, { useState, lazy, useRef } from "react";

import Message from "../../Message";
import SuccessRes from "./SuccessRes";
import { editShipmentSchema } from "../../../../joi/shipmentSchema";
import { editShipmentSetData } from "../../../../../context/api/shipment/edit-shipment/editShipmentSetData";
import { useCookies } from "react-cookie";
// Bootstrap
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useEffect } from "react";
import Spinner from "react-bootstrap/Spinner";

// Joi Improvements 
import Joi from 'joi';

const EditShipmentModal = ({
    show,
    onHide,
    lang,
    action,
    userId,
    data,
    setRefreshData,
    menuLoading,
    menuData,
}) => {
    const dataTranslate = require(`../../../../../translate/${lang === "AR" ? "arabic" : "english"
        }/data.json`);
    const schema = editShipmentSchema(lang);
    const initialMessageRes = {
        success: Boolean,
        message: String,
        isShow: false,
    };

    const initialSuccessMessage = {
        success: false,
        type: "",
        data: {},
    };

    const [shipment, setShipment] = useState({
    });

    // const fetched = useRef(false);
    const [errors, setErrors] = useState({});
    const [messageResponse, setMessageResponse] = useState(initialMessageRes);
    const [successMessage, setSuccessMessage] = useState(initialSuccessMessage);
    const [cookies] = useCookies();
    const [btnLoader, setBtnLoader] = useState(false);

    // get last 5 shipping id from the backend 


    const editShipment = () => {
        var objectSchema = Joi.object().keys(schema);
        const result = objectSchema.validate(shipment, { abortEarly: false });
        const { error } = result;
        if (!error) {
            // pass the payload to the context API to do the request
            setBtnLoader(() => true);
            return editShipmentSetData(
                lang,
                setMessageResponse,
                cookies,
                shipment,
                setSuccessMessage,
                setBtnLoader,
                data.id
            );
        } else {
            const errorData = {};
            for (let item of error.details) {
                const name = item.path[0];
                const message = item.message;
                errorData[name] = message;
            }
            setErrors(errorData);
            return errorData;
        }
    };

    const handleOnChange = (e) => {
        const { name, value } = e.target;
        let errorData = { ...errors };
        const errorMessage = validateProperty(e);
        if (errorMessage) {
            errorData[name] = errorMessage;
        } else {
            delete errorData[name];
        }
        let shipmentData = { ...shipment };
        shipmentData[name] = value;
        setShipment(shipmentData);
        setErrors(errorData);
    }

    const validateProperty = (event) => {
        const { name, value } = event.target;
        const obj = { [name]: value };
        const subSchema = schema[name];
        const result = subSchema.validate(value);
        const { error } = result;
        return error ? error.details[0].message : null;
    };

    const reset = () => {
        setShipment({
        })
        setErrors({
        })
    }
    return (
        <>
            <Message
                messageResponse={messageResponse}
                close={() => setMessageResponse(initialMessageRes)}
                lang={lang}
            />

            <Modal
                show={show}
                onHide={onHide}
                backdrop="static"
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className="forget-pass-otp-form"
                dir={lang === "AR" ? "rtl" : "ltr"}
            >
                {successMessage.success ? (
                    <SuccessRes
                        lang={lang}
                        dataTranslate={dataTranslate}
                        onHide={async () => {
                            await onHide();
                            setSuccessMessage(initialSuccessMessage);
                            setRefreshData((prev) => prev + 1);
                        }}
                        res={successMessage}
                    />
                ) : (
                    <>
                        <Modal.Header className="d-flex align-items-center justify-content-center ">
                            <Modal.Title
                                id="contained-modal-title-vcenter"
                                className="fs-2 d-flex flex-row gap-2"
                            >
                                <span>
                                    {`${dataTranslate.popups.customerShipment_tab.records.update_title} ${data.id}`}
                                </span>
                            </Modal.Title>
                        </Modal.Header>
                        {/* {!menuLoading ? <>
                            <div className="menuLoader">
                                <Spinner animation="border" variant="warning" />
                            </div>
                        </> : ""} */}
                        <Modal.Body className="mx-5">
                            <div dir={lang === "AR" ? "rtl" : ""}>
                                <Container>
                                    <Row className="mb-lg-3">
                                        {/* <Col lg={6} sm={12} className="mb-3 mb-lg-0">
                                            <Form.Group>
                                                <Form.Label>
                                                    {dataTranslate.popups.customerShipment_tab.records.shipping_id}
                                                    {action === "add" ? (
                                                        <span>
                                                            <sup style={{ color: "red" }}> *</sup>
                                                        </span>
                                                    ) : (
                                                        ""
                                                    )}
                                                </Form.Label>
                                                <Form.Select
                                                    name="shipping_id"
                                                    defaultValue=""
                                                    onChange={handleOnChange}
                                                >
                                                    <option selected disabled>
                                                    {dataTranslate.popups.customerShipment_tab.select.id} {data.shipping_id} - {dataTranslate.popups.customerShipment_tab.select.containerNumber} {data.containerNumber}
                                                    </option>
                                                    {menuData.map((item) => {
                                                        return (
                                                            <option value={item.id}>
                                                                {dataTranslate.popups.customerShipment_tab.select.id} {item.id} - {dataTranslate.popups.customerShipment_tab.select.containerNumber} {item.containerNumber}
                                                            </option>
                                                        )
                                                    })}



                                                </Form.Select>


                                                <Form.Text style={{ color: "red" }}>
                                                    {errors.shipping_id}
                                                </Form.Text>
                                            </Form.Group>
                                        </Col> */}
                                        

                                        <Col lg={6} sm={12} className="mb-3 mb-lg-0">
                                            <Form.Group>
                                                <Form.Label>
                                                    {
                                                        dataTranslate.popups.customerShipment_tab.records
                                                            .shippingCost_cubic_per_meter
                                                    }

                                                </Form.Label>
                                                <Form.Control
                                                    // disabled={!menuLoading ? true : false}
                                                    type="number"
                                                    name="shippingCost_cubic_per_meter"
                                                    placeholder={
                                                        dataTranslate.popups.customerShipment_tab.records
                                                            .shippingCost_cubic_per_meter_p
                                                    }
                                                    defaultValue={
                                                        data.shippingCost_cubic_per_meter
                                                    }
                                                    onChange={handleOnChange}
                                                />

                                                <Form.Text style={{ color: "red" }}>
                                                    {errors.shippingCost_cubic_per_meter}
                                                </Form.Text>
                                            </Form.Group>
                                        </Col>

                                        <Col lg={6} sm={12} className="mb-3 mb-lg-0">
                                            <Form.Group>
                                                <Form.Label>
                                                    {dataTranslate.popups.customerShipment_tab.records.totalCBM}

                                                </Form.Label>
                                                <Form.Control
                                                    // disabled={!menuLoading ? true : false}
                                                    type="number"
                                                    name="totalCBM"
                                                    placeholder={
                                                        dataTranslate.popups.customerShipment_tab.records
                                                            .totalCBM_p
                                                    }
                                                    defaultValue={data.totalCBM}
                                                    onChange={handleOnChange}
                                                />

                                                <Form.Text style={{ color: "red" }}>
                                                    {errors.totalCBM}
                                                </Form.Text>
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                    <Row className="mb-lg-3">
                                        <Col lg={6} sm={12} className="mb-3 mb-lg-0">
                                            <Form.Group>
                                                <Form.Label>
                                                    {
                                                        dataTranslate.popups.customerShipment_tab.records
                                                            .shippingFees
                                                    }
                                                </Form.Label>
                                                <Form.Control
                                                    // disabled={!menuLoading ? true : false}
                                                    type="number"
                                                    name="shippingFees"
                                                    placeholder={
                                                        dataTranslate.popups.customerShipment_tab.records
                                                            .shippingFee_p
                                                    }
                                                    defaultValue={data.shippingFees}
                                                    onChange={handleOnChange}
                                                />

                                                <Form.Text style={{ color: "red" }}>
                                                    {errors.shippingFees}
                                                </Form.Text>
                                            </Form.Group>
                                        </Col>

                                        <Col lg={6} sm={12} className="mb-3 mb-lg-0">
                                            <Form.Group>
                                                <Form.Label>
                                                    {
                                                        dataTranslate.popups.customerShipment_tab.records
                                                            .containerNumber
                                                    }
                                                </Form.Label>
                                                <Form.Control
                                                    // disabled={!menuLoading ? true : false}
                                                    name="containerNumber"
                                                    placeholder={
                                                        dataTranslate.popups.customerShipment_tab.records
                                                            .containerNumber_p
                                                    }
                                                    defaultValue={
                                                        data.containerNumber
                                                    }
                                                    onChange={handleOnChange}
                                                />

                                                <Form.Text style={{ color: "red" }}>
                                                    {errors.containerNumber}
                                                </Form.Text>
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                    <Row className="mb-lg-3">
                                        <Col lg={6} sm={12} className="mb-3 mb-lg-0">
                                            <Form.Group>
                                                <Form.Label>
                                                    {dataTranslate.popups.customerShipment_tab.records.trackingId}
                                                </Form.Label>
                                                <Form.Control
                                                    // disabled={!menuLoading ? true : false}
                                                    name="trackingId"
                                                    placeholder={
                                                        dataTranslate.popups.customerShipment_tab.records.trackingId_p
                                                    }
                                                    defaultValue={data.trackingId}
                                                    onChange={handleOnChange}
                                                />

                                                <Form.Text style={{ color: "red" }}>
                                                    {errors.trackingId}
                                                </Form.Text>
                                            </Form.Group>
                                        </Col>

                                        <Col lg={6} sm={12} className="mb-3 mb-lg-0">
                                            <Form.Group>
                                                <Form.Label>
                                                    {dataTranslate.popups.customerShipment_tab.records.totalBoxs}
                                                </Form.Label>
                                                <Form.Control
                                                    // disabled={!menuLoading ? true : false}
                                                    type="number"
                                                    name="totalBoxs"
                                                    placeholder={
                                                        dataTranslate.popups.customerShipment_tab.records.totalBoxs
                                                    }
                                                    defaultValue={
                                                        data.totalBoxs
                                                    }
                                                    onChange={handleOnChange}
                                                />

                                                <Form.Text style={{ color: "red" }}>
                                                    {errors.totalBoxs}
                                                </Form.Text>
                                            </Form.Group>
                                        </Col>


                                    </Row>

                                    <Row className="mb-lg-3">
                                        <Col lg={6} sm={12} className=" mb-lg-0">
                                            <Form.Group>
                                                <Form.Label>
                                                    {dataTranslate.popups.customerShipment_tab.records.totalPeices}
                                                </Form.Label>
                                                <Form.Control
                                                    // disabled={!menuLoading ? true : false}
                                                    type="number"
                                                    name="totalPeices"
                                                    placeholder={
                                                        dataTranslate.popups.customerShipment_tab.records.totalPeices
                                                    }
                                                    defaultValue={
                                                        data.totalPeices
                                                    }
                                                    onChange={handleOnChange}
                                                />

                                                <Form.Text style={{ color: "red" }}>
                                                    {errors.totalPeices}
                                                </Form.Text>
                                            </Form.Group>
                                        </Col>

                                        <Col lg={6} sm={12} className="mb-3 mb-lg-0">
                                            <Form.Group>
                                                <Form.Label>
                                                    {dataTranslate.popups.customerShipment_tab.records.notes}
                                                </Form.Label>
                                                <Form.Control
                                                    // disabled={!menuLoading ? true : false}
                                                    name="NB"
                                                    as="textarea"
                                                    placeholder={
                                                        dataTranslate.popups.customerShipment_tab.records.notes
                                                    }
                                                    defaultValue={data.NB}
                                                    onChange={handleOnChange}
                                                />

                                                <Form.Text style={{ color: "red" }}>
                                                    {errors.NB}
                                                </Form.Text>
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                    <Row className="mb-lg-3">
                                        <Col lg={6} sm={12} className="mb-3 mb-lg-0">
                                            <Form.Group>
                                                <Form.Label>
                                                    {dataTranslate.popups.customerShipment_tab.records.recordDate}
                                                </Form.Label>
                                                <Form.Control
                                                    name="recordDate"
                                                    type="date"
                                                    defaultValue={data.recordDateYYYYMMDD}
                                                    onChange={handleOnChange}
                                                />

                                                <Form.Text style={{ color: "red" }}>
                                                    {errors.recordDate}
                                                </Form.Text>
                                            </Form.Group>
                                        </Col>
                                        <Col lg={6} sm={12} className="mb-3 mb-lg-0">
                                            <Form.Group>
                                                <Form.Label>
                                                    {dataTranslate.popups.exports_tab.records.exchangeRateRMB}
                                                    {action === "add" ? (
                                                        <span>
                                                            <sup style={{ color: "red" }}> *</sup>
                                                        </span>
                                                    ) : (
                                                        ""
                                                    )}
                                                </Form.Label>
                                                <Form.Control
                                                    name="exchangeRateRMB"
                                                    type="number"
                                                    placeholder={
                                                        dataTranslate.popups.exports_tab.records.exchangeRateRMB_p
                                                    }
                                                    defaultValue={data.exchangeRateRMB}
                                                    onChange={handleOnChange}
                                                    onKeyUp={(e) => {
                                                        setShipment((old) => ({
                                                            ...old,
                                                            exchangeRateRMB: parseFloat(e.target.value),
                                                        }))
                                                    }}
                                                />

                                                <Form.Text style={{ color: "red" }}>
                                                    {errors.exchangeRateRMB}
                                                </Form.Text>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </Container>
                            </div>
                        </Modal.Body>
                        <Modal.Footer
                            className="w-100 d-flex flex-row align-items-center"
                            dir="ltr"
                            style={{ zIndex: '1001' }}
                        >
                            <div className="w-100 double-btns d-flex flex-row align-items-center justify-content-center gap-2">
                                <Button
                                    onClick={(e) => {
                                        editShipment();
                                    }}
                                    disabled={(btnLoader) ? true : false}
                                // disabled={btnLoader ? true : false}
                                // className="disableBTN"
                                >
                                    {dataTranslate.popups.customerShipment_tab.records.update}
                                </Button>

                                <Button
                                    onClick={() => {
                                        reset();
                                        onHide();
                                    }}
                                >
                                    {dataTranslate.popups.customerShipment_tab.records.close}
                                </Button>
                            </div>
                        </Modal.Footer>
                    </>
                )}
            </Modal>
        </>
    );
};

export default EditShipmentModal;
